import styled from 'styled-components';

import { PayerType } from '../shared/DischargeCalendarPatientCard';

interface MonthViewAggregateCardProps {
  count: number;
  payerType: PayerType;
}

export default function MonthViewAggregateCard({ count, payerType }: MonthViewAggregateCardProps) {
  const label = payerType === 'medicare' ? 'Medicare' : 'Other';

  return (
    <Card $payerType={payerType} data-cy='month-view-aggregate-card'>
      {count} {label}
    </Card>
  );
}

const Card = styled.div<{ $payerType: PayerType }>`
  padding: 8px 10px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: var(--font-weight-medium);
  color: ${({ theme }) => theme.colors.black100};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  background-color: ${({ $payerType, theme }) =>
    $payerType === 'medicare' ? theme.colors.green10 : theme.colors.lightBlue10};

  border-left: 3px solid
    ${({ $payerType, theme }) => ($payerType === 'medicare' ? theme.colors.green100 : theme.colors.lightBlue100)};
`;
